import * as React from 'react';
import { AssignedTicketsWidget } from '../Widgets/AssignedTicketsWidget';
import { UsefulLinksWidget } from '../../CoreComponents/UsefulLinksWidget';
import { DashboardOrganizationState } from '../interfaces';
import { GetSettings } from '../../../functions/StateManagement/StateStorageFunctions';
import { RenderSettings } from '../../../interfaces/WidgetSettingsInterfaces';
import DashboardHeaderRow from '../../CoreComponents/DashboardHeaderRow';
import { DashboardOrganizer, DefaultPageSettings } from '../../../functions/WidgetDashboardOrganizer';

export default class PropertyAccountantDashboard extends React.Component<{}, DashboardOrganizationState> {

  settingsString: "propertyAccountingDashboard";

  constructor(props: {}) {
    super(props);
    let settings: RenderSettings = GetSettings<RenderSettings>(this.settingsString);
    if (settings === null) {
      settings = DefaultPageSettings
    }
    this.state = {
      renderSettings: settings,
      displayWidgets: [],
      widgetList: []
    }
    DashboardOrganizer.bind(this);
  }

  async prepareDasboard(): Promise<void> {
    let displayWidgets: { [key: number]: JSX.Element } = {
      0: <AssignedTicketsWidget />,
      1: <UsefulLinksWidget />
    }
    let widgetList = [
      { label: "New Tickets", value: "0" },
      { label: "Employee Management", value: "1" },
    ]
    this.setState({
      displayWidgets: displayWidgets,
      widgetList: widgetList
    })
  }

  updateUI = (settings: RenderSettings): void => {
    this.setState({ renderSettings: settings })
  }

  render(): JSX.Element {
    return (
      <>
        <DashboardHeaderRow
          dashboardTitle={"Property Accounting Dashboard"}
          settingsString={this.settingsString}
          displayList={this.state.displayWidgets}
          widgetList={this.state.widgetList}
          updateUI={this.updateUI}
        />
        {DashboardOrganizer(this.state.displayWidgets, this.state.renderSettings)}
      </>
    )
  }
}